import { FormLayout } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { InferType } from "yup";
import APIS from "../../constant/EndPoint";
import { createUserValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import Modal from "../Reusable/Modal";
import MultipleSelectField from "../Reusable/MultiSelectField";
import TextField from "../Reusable/TextInput";
import CreateUser from "./CreateUser";
import useGetHook from "../../customHooks/useGetHook";
import UserComboboxInput from "../Reusable/UserComboBox";

const CreateMerchant = (props: any) => {
  const {
    handleCreate,
    isLoading,
    openAddReceiverPopup,
    setOpenAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    handleCreateUser,
    isuserloading,
    setOpenUserFormPopup,
    openUserFormPopup,
  } = props;
  const { data: code, refetch } = useGetHook({
    queryKey: ["next-series"],
    url: `${APIS.CODE}/`,
    params: {},
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<InferType<typeof createUserValidationForm>>({
    resolver: yupResolver(createUserValidationForm),
    values: {
      code: code?.next_code || "",
      short_code: "",
      st_charge: 0,
    },
  });
  type FormValues = InferType<typeof createUserValidationForm>;

  const selectedUser = watch("user");

  console.log("hello", selectedUser);

  const fullName =
    typeof selectedUser === "string"
      ? selectedUser
      : selectedUser &&
        typeof selectedUser === "object" &&
        "name" in selectedUser
      ? (selectedUser as any).name || ""
      : "";
  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
          <div className={tw`w-full flex items-start justify-center space-x-1`}>
            <div className={tw`w-full`}>
              <UserComboboxInput
                url={APIS.USER}
                queryKey="user"
                register={register("user")}
                name="user"
                label="User"
                setValue={(field: keyof FormValues, value: any) => {
                  setValue(field, value);
                  let fullName = "";
                  if (value && typeof value === "object") {
                    fullName =
                      value.name ||
                      value.username ||
                      value.profile?.full_name ||
                      "";
                  } else if (typeof value === "string") {
                    fullName = value;
                  }
                  console.log("fullName", fullName);

                  if (fullName && code?.next_code) {
                    const cleanName = fullName.trim();
                    const words = cleanName
                      .split(/\s+/)
                      .filter((w) => w.length > 0)
                      .map((w) => w.replace(/[^a-zA-Z]/g, "").toUpperCase())
                      .filter((w) => w.length > 0);

                    let initials = "";
                    if (words.length >= 2) {
                      initials = words[0][0] + words[1][0];
                    } else if (words.length === 1 && words[0].length >= 2) {
                      initials = words[0].substring(0, 2);
                    } else if (words.length === 1) {
                      initials = words[0];
                    } else {
                      initials = "xx";
                    }

                    const generatedShortCode = `${initials}-${code.next_code}`;
                    console.log("Generated short code:", generatedShortCode);
                    setValue("short_code", generatedShortCode);
                  } else {
                    setValue("short_code", "");
                  }
                }}
                errors={errors?.user}
                props={{
                  is_active: true,
                  is_staff: false,
                  is_rider: false,
                  is_superuser: false,
                }}
                placeholder="Search user"
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button
              className={tw`border px-4 py-1 text-xl relative top-9  bg-[#EEF5F4] focus:outline-none`}
              type="button"
              onClick={() => setOpenUserFormPopup(!openUserFormPopup)}
            >
              +
            </button>
          </div>
          <TextField
            label={"Code"}
            register={register("code")}
            errors={errors?.code}
          />
          <TextField
            label={"Short Code"}
            register={register("short_code")}
            errors={errors?.short_code}
          />
          <TextField
            label={"Exim Code"}
            register={register("exim_code")}
            errors={errors?.exim_code}
          />
          <TextField
            label={"Company Name"}
            register={register("company_name")}
            errors={errors?.company_name}
          />
          <TextField
            label={"PAN/VAT"}
            register={register("vat_pan")}
            errors={errors?.vat_pan}
          />
          <MultipleSelectField
            errors={errors?.service_type}
            queryKey={"service-type"}
            label={"Service Type"}
            register={register("service_type")}
            watch={watch}
            setValue={setValue}
            clearErrors={clearErrors}
            props={{
              is_active: true,
            }}
            url={APIS.SERVICE_TYPE}
            value={[]}
          />
          <MultipleSelectField
            errors={errors?.product_type}
            label={"Product Type"}
            queryKey={"product-type"}
            register={register("product_type")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
            }}
            url={APIS.PRODUCT_TYPE}
            clearErrors={clearErrors}
            value={[]}
          />
          <MultipleSelectField
            errors={errors?.payment_method}
            label={"Payment Method"}
            queryKey={"payment-method"}
            register={register("payment_method")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
            }}
            url={APIS.PAYMENT_METHOD_TYPE}
            clearErrors={clearErrors}
            value={[]}
          />
          <MultipleSelectField
            errors={errors?.service_branch}
            label={"Service Branch"}
            queryKey={"service-branch"}
            register={register("service_branch")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
            }}
            url={APIS.BRANCH}
            clearErrors={clearErrors}
            value={[]}
          />
          <MultipleSelectField
            errors={errors?.service_city}
            label={"Service City"}
            queryKey={"service-city"}
            register={register("service_city")}
            watch={watch}
            setValue={setValue}
            url={`${APIS.LOCATION}flat-location/`}
            value={[]}
            clearErrors={clearErrors}
            props={{
              level: 3,
              is_active: true,
            }}
          />
          <ComboboxInput
            url={APIS.DELIVERY_CHARGE_TEMPLATE}
            queryKey={"delivery-charge-template"}
            register={register("delivery_charge_template")}
            errors={errors?.delivery_charge_template}
            name={"delivery_charge_template"}
            label={"Rate Template"}
            props={{
              is_active: true,
              is_branch: false,
            }}
            setValue={setValue}
            placeholder={"Search Rate Template"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.PRODUCT_TYPE}
            props={{
              is_active: true,
            }}
            queryKey={"product-type"}
            register={register("default_product_type")}
            errors={errors?.default_product_type}
            name={"default_product_type"}
            label={"Default Product Type"}
            setValue={setValue}
            placeholder={"Search Default Product Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <div>
            <div className={tw`w-full mt-2`}>
              <span>Default Sender</span>
            </div>
            <div
              className={tw`w-full flex items-start justify-center space-x-1`}
            >
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.CUSTOMER}
                  queryKey={"customer"}
                  register={register("default_sender")}
                  errors={errors?.default_sender}
                  name={"default_sender"}
                  setValue={setValue}
                  props={{
                    is_active: true,
                  }}
                  placeholder={"Search Default Sender"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>

              <button
                className={tw`border px-4 py-1 text-xl mt-2 bg-[#EEF5F4] focus:outline-none`}
                type="button"
                onClick={() => setOpenAddSenderPopup(!openAddSenderPopup)}
              >
                +
              </button>
            </div>
          </div>
        </div>
        <div className={tw`grid grid-cols-2 md:grid-cols-2 gap-x-4 mx-4`}>
          
          <div>
            <div className={tw`w-full mt-2`}>
              <span>Default Receiver</span>
            </div>
            <div
              className={tw`w-full flex justify-center items-start space-x-1`}
            >
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.CUSTOMER}
                  props={{
                    is_active: true,
                  }}
                  queryKey={"customer"}
                  register={register("default_receiver")}
                  errors={errors?.default_receiver}
                  name={"default_receiver"}
                  setValue={setValue}
                  placeholder={"Search Default Receiver"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4 py-1 text-xl mt-2 bg-[#EEF5F4] focus:outline-none`}
                type="button"
                onClick={() => setOpenAddReceiverPopup(!openAddReceiverPopup)}
              >
                +
              </button>
            </div>
          </div>
          <ComboboxInput
            url={APIS.PAYMENT_METHOD_TYPE}
            props={{
              is_active: true,
            }}
            queryKey={"payment-method-type"}
            register={register("default_payment_method")}
            errors={errors?.default_payment_method}
            name={"default_payment_method"}
            label={"Default Payment Method"}
            setValue={setValue}
            placeholder={"Search Default Payment Method"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{
              is_active: true,
            }}
            queryKey={"service-type"}
            register={register("default_service_type")}
            errors={errors?.default_service_type}
            name={"default_service_type"}
            label={"Default Service Type"}
            setValue={setValue}
            placeholder={"Search Default Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <TextField
            label={"St. Charge "}
            register={register(`st_charge`)}
            errors={errors?.st_charge}
          />
        </div>
      </FormLayout>
      <Modal
        title={"Create User"}
        isOpen={openUserFormPopup}
        setIsOpen={setOpenUserFormPopup}
      >
        <CreateUser handleCreate={handleCreateUser} isLoading={isuserloading} />
      </Modal>
    </>
  );
};

export default CreateMerchant;
